import { Component, inject, signal, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Auth } from '../../../services/auth';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { environment } from '../../../../environments/environment';
import { ForgotPassword } from '../forgot-password/forgot-password';
import { finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

interface DemoUser {
  label: string;
  username: string;
  password: string;
}

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, MatButtonModule, MatInputModule, MatIconModule, MatProgressSpinnerModule, MatSelectModule, NgOptimizedImage],
  templateUrl: './login.html',
  styleUrl: './login.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Login implements OnInit {

  imgSrc = environment.logoUrl;
  isDemo = environment.demo;

  private authService = inject(Auth);
  private dialog = inject(MatDialog);
  private toastr = inject(ToastrService);

  isLoading = signal(false);
  hidePassword = signal(true);

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  demoUsers: DemoUser[] = [
    { label: 'Admin', username: 'Admin', password: 'Admin' },
    { label: 'Bekuldo', username: 'Bekuldo', password: 'Bekuldo' },
    { label: 'Leletezo', username: 'Leletezo', password: 'Leletezo' },
  ];

  selectedDemoUser = signal<DemoUser | null>(null);

  ngOnInit(): void {
    this.authService.initializeAuth(true);
  }

  onDemoUserSelected(user: DemoUser) {
    this.selectedDemoUser.set(user);
    this.loginForm.setValue({ username: user.username, password: user.password });
  }

  login() {
    if (this.loginForm.invalid) {
      this.markFormGroupTouched();
      return;
    }

    this.isLoading.set(true);

    const { username, password } = this.loginForm.value;

    this.authService.login(username!, password!)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: () => {
          // Navigation will be handled by auth service after user is loaded
        },
        error: (error) => {
          this.toastr.error('Hiba történt a bejelentkezés során!', 'Hiba');
        }
      });
  }

  private markFormGroupTouched(): void {
    Object.keys(this.loginForm.controls).forEach(key => {
      const control = this.loginForm.get(key);
      control?.markAsTouched();
    });
  }

  forgotPassword() {
    this.dialog.open(ForgotPassword, {
      minWidth: '800px',
      disableClose: false,
    });
  }

}
